<div class="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
  <div class="w-full max-w-lg">

    <!-- Header -->
    <div class="text-center mb-8">
      <div class="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-blue-500/20 border border-blue-500/30 mb-4">
        <svg class="w-8 h-8 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      </div>
      <h1 class="text-2xl font-bold text-white">Set Up Your Committee</h1>
      <p class="text-slate-400 mt-2 text-sm">Enter your village committee details to get started.</p>
    </div>

    <!-- Card -->
    <div class="bg-slate-800/60 backdrop-blur border border-slate-700/50 rounded-2xl p-8 shadow-2xl">

      <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>

        <!-- Village Name -->
        <div class="mb-5">
          <label class="block text-sm font-medium text-slate-300 mb-2">Village / Committee Name <span class="text-red-400">*</span></label>
          <input
            type="text"
            formControlName="villageName"
            placeholder="e.g. Colombo 07 Village Committee"
            class="w-full px-4 py-3 rounded-xl bg-slate-700/50 border border-slate-600/50 text-white placeholder-slate-500 focus:outline-none focus:border-blue-500/70 focus:ring-1 focus:ring-blue-500/30 transition-colors"
            [class.border-red-500]="f['villageName'].invalid && f['villageName'].touched"
          />
          @if (f['villageName'].invalid && f['villageName'].touched) {
            <p class="text-red-400 text-xs mt-1">Village name is required (min. 2 characters).</p>
          }
        </div>

        <!-- Address -->
        <div class="mb-5">
          <label class="block text-sm font-medium text-slate-300 mb-2">Address <span class="text-red-400">*</span></label>
          <input
            type="text"
            formControlName="address"
            placeholder="e.g. No. 12, Main Street, Colombo 07"
            class="w-full px-4 py-3 rounded-xl bg-slate-700/50 border border-slate-600/50 text-white placeholder-slate-500 focus:outline-none focus:border-blue-500/70 focus:ring-1 focus:ring-blue-500/30 transition-colors"
            [class.border-red-500]="f['address'].invalid && f['address'].touched"
          />
          @if (f['address'].invalid && f['address'].touched) {
            <p class="text-red-400 text-xs mt-1">Address is required.</p>
          }
        </div>

        <!-- Contact Phone -->
        <div class="mb-5">
          <label class="block text-sm font-medium text-slate-300 mb-2">Contact Phone</label>
          <input
            type="tel"
            formControlName="contactPhone"
            placeholder="e.g. 0112 345 678"
            class="w-full px-4 py-3 rounded-xl bg-slate-700/50 border border-slate-600/50 text-white placeholder-slate-500 focus:outline-none focus:border-blue-500/70 focus:ring-1 focus:ring-blue-500/30 transition-colors"
          />
        </div>

        <!-- Contact Email -->
        <div class="mb-6">
          <label class="block text-sm font-medium text-slate-300 mb-2">Contact Email</label>
          <input
            type="email"
            formControlName="contactEmail"
            placeholder="e.g. info@committee.lk"
            class="w-full px-4 py-3 rounded-xl bg-slate-700/50 border border-slate-600/50 text-white placeholder-slate-500 focus:outline-none focus:border-blue-500/70 focus:ring-1 focus:ring-blue-500/30 transition-colors"
            [class.border-red-500]="f['contactEmail'].invalid && f['contactEmail'].touched"
          />
          @if (f['contactEmail'].invalid && f['contactEmail'].touched) {
            <p class="text-red-400 text-xs mt-1">Please enter a valid email address.</p>
          }
        </div>

        <!-- Error -->
        @if (errorMessage) {
          <div class="mb-4 p-3 rounded-lg bg-red-500/10 border border-red-500/30 text-red-400 text-sm">
            {{ errorMessage }}
          </div>
        }

        <!-- Submit -->
        <button
          type="submit"
          [disabled]="isSubmitting"
          class="w-full py-3 px-4 rounded-xl font-semibold text-white bg-blue-600 hover:bg-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          @if (isSubmitting) {
            <span class="inline-flex items-center gap-2">
              <svg class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
              </svg>
              Creating...
            </span>
          } @else {
            Create Committee
          }
        </button>

      </form>
    </div>

  </div>
</div>
